import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'publisher',
	prefix: 'publisher',
	key: 'publisher_id',
	fields: {
		publisher_id: Model.SCHEMA_NUMBER,
		publisher_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				publisher_id: this.get_id(),
				publisher_name: this.rawData().publisher_name
			}
		}
	}
})
